import React from "react";
import ProjectMessage from "../../projects/tabs/message";

function Messages({teamData}) {
    return <ProjectMessage teamData={teamData} teamAccess={{isReadOnly: false}}/>;
}

export default Messages;